import React from "react";
import PropTypes from "prop-types";
import styles from "./Button.module.css";
import classNames from "classnames";

/**
 * Interactive component. A multi-purpose button that changes appearance on hover.
 */

export function Button({ text, className, onClick, disabled }) {
  return (
    <button
      type="button"
      className={classNames(styles.btn, styles[className], {
        [styles.disabled]: disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.text}>{text}</div>
    </button>
  );
}

Button.propTypes = {
  /**
   * Function that fires on button click.
   */
  onClick: PropTypes.func,
  /**
   * A String for the button text.
   */
  text: PropTypes.string,
  /**
   * String that can alter style.
   */
  className: PropTypes.string,
  disabled: PropTypes.bool,
};
